module.exports = __webpack_public_path__ + "img/1.5cc5f946.png";